import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["switch", "label", "onLabel", "offLabel"]
  static values = {
    url: String,
    field: String,
    enabled: Boolean,
    namespace: String,
    onColor: { type: String, default: "bg-green" },
    offColor: { type: String, default: "bg-gray-300" }
  }

  connect() {
    this.updateVisual()
  }

  toggle(event) {
    this.enabledValue = !this.enabledValue
    this.updateVisual()

    if (this.hasUrlValue && this.urlValue) {
      this.persistChange()
    }
  }

  updateVisual() {
    const on = this.onColorValue
    const off = this.offColorValue

    if (this.hasSwitchTarget) {
      const knob = this.switchTarget.querySelector('span')
      if (this.enabledValue) {
        this.switchTarget.classList.remove(off, 'dark:bg-gray-700')
        this.switchTarget.classList.add(on)
        knob?.classList.remove('translate-x-1')
        knob?.classList.add('translate-x-6')
      } else {
        this.switchTarget.classList.add(off, 'dark:bg-gray-700')
        this.switchTarget.classList.remove(on)
        knob?.classList.add('translate-x-1')
        knob?.classList.remove('translate-x-6')
      }
      this.switchTarget.setAttribute('aria-checked', this.enabledValue)
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.enabledValue ? 'Enabled' : 'Disabled'
      this.labelTarget.classList.toggle('text-emerald-600', this.enabledValue)
      this.labelTarget.classList.toggle('text-gray-500', !this.enabledValue)
    }

    if (this.hasOnLabelTarget) {
      this.onLabelTarget.classList.toggle('text-green', this.enabledValue)
      this.onLabelTarget.classList.toggle('dark:text-green', this.enabledValue)
      this.onLabelTarget.classList.toggle('text-gray-400', !this.enabledValue)
      this.onLabelTarget.classList.toggle('dark:text-gray-500', !this.enabledValue)
    }

    if (this.hasOffLabelTarget) {
      this.offLabelTarget.classList.toggle('text-gray-400', this.enabledValue)
      this.offLabelTarget.classList.toggle('dark:text-gray-500', this.enabledValue)
      this.offLabelTarget.classList.toggle('text-gray-900', !this.enabledValue)
      this.offLabelTarget.classList.toggle('dark:text-white', !this.enabledValue)
    }
  }

  persistChange() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const fieldData = { [this.fieldValue]: this.enabledValue }
    const payload = this.hasNamespaceValue && this.namespaceValue
      ? { [this.namespaceValue]: fieldData }
      : fieldData

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => response.json())
    .then(data => {
      if (!data.success) {
        this.enabledValue = !this.enabledValue
        this.updateVisual()
        console.error('[Toggle] Update failed:', data.error)
      }
    })
    .catch(error => {
      this.enabledValue = !this.enabledValue
      this.updateVisual()
      console.error('[Toggle] Error:', error)
    })
  }
}
